import React from 'react'
import SEO from '../components/common/SEO'
import ServicesBanner from '../components/services/ServicesBanner'
import ServicesOverview from '../components/services/ServicesOverview'
import ServicesGrid from '../components/services/ServicesGrid'
import HeroWhyChoose from '../components/common/HeroWhyChoose'
import WorkProcess from '../components/common/WorkProcess'
import IndustriesSection from '../components/services/IndustriesSection'
import FaqSection from '../components/common/FaqSection'
import CTASection from '../components/common/CTASection'

const Services = () => {
  return (
    <>
      <SEO
        title="Construction & Property Services | AZ Construction Indore"
        description="Explore AZ Construction's professional services including residential construction, commercial construction, property development, property dealing, renovation, and liaisoning services in Indore."
        url="https://azconstruction.com/services"
      />
      <ServicesBanner />
      <ServicesOverview />
      <ServicesGrid />
      <HeroWhyChoose />
      <WorkProcess />
      <IndustriesSection />
      <FaqSection />
      <CTASection />
    </>
  )
}

export default Services